// start:ng42.barrel
export * from './constants';
export * from './core.module';
export * from './local-storage.service';
export * from './route-reusable-strategy';
export * from './class';
export * from './http';
export * from './lib';
export * from './lib/UAParserService';
export * from './service';
export * from './static';
// end:ng42.barrel
